import { render, staticRenderFns } from "./AreaPermit.vue?vue&type=template&id=14f3d9c5"
import script from "./AreaPermit.vue?vue&type=script&lang=js"
export * from "./AreaPermit.vue?vue&type=script&lang=js"
import style0 from "./AreaPermit.vue?vue&type=style&index=0&id=14f3d9c5&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports